import React from 'react';
import TagManager from 'react-gtm-module';

import { useViewerSubscriptionQuery } from '@edx/graphql/generated';
import { useAppConfigStateContext } from '@edx/contexts/app-config';
import { Navbar } from '@edx/components/navbar';
import { Footer, FooterColumn } from '@edx/components/footer';
import { NavbarLinkProps } from '@edx/components/navbar/components/navbar-link/navbar-link';

import EDBLogo from '@edx/img/edb-logo.svg';
import NOISE_PATTERN from '@edx/img/noise_pattern.png';

type Props = {
  navBarLinks: NavbarLinkProps[];
  footerColumns: FooterColumn[];
  simpleFooter: boolean;
  simpleNavBar: boolean;
};

export const Page: React.FC<Props> = ({ navBarLinks, footerColumns, simpleFooter, simpleNavBar, children }) => {
  const { projectName } = useAppConfigStateContext();
  const { loading, data } = useViewerSubscriptionQuery();

  const viewer = data?.viewer;

  React.useEffect(() => {
    if (!process.env.NEXT_PUBLIC_GTM_KEY || loading) return;

    TagManager.initialize({
      gtmId: process.env.NEXT_PUBLIC_GTM_KEY,
      events: {
        subscriptionCreated: 'Subscription created',
        userCreated: 'User created',
      },
      dataLayer: {
        internalTraffic: Boolean(viewer?.isInternalTraffic),
        isLoggedIn: Boolean(viewer?.id),
        isSubscribed: Boolean(viewer?.subscription?.isValid),
        userId: viewer?.id,
      },
    });
  }, [viewer, loading]);

  return (
    <main className="flex flex-col min-h-screen" style={{ background: `#292929 url(${NOISE_PATTERN}) repeat` }}>
      {simpleNavBar ? (
        <nav className="w-full z-40 absolute top-0">
          <div className="max-w-6xl mx-auto px-4 md:px-10 py-1 md:py-4 flex justify-center">
            <img src={EDBLogo} alt={projectName} className="w-10 h-10 md:w-14 md:h-14" />
          </div>
        </nav>
      ) : (
        <Navbar logo={EDBLogo} links={navBarLinks} />
      )}

      <div className="flex flex-1 flex-col" style={{ background: `#292929 url(${NOISE_PATTERN}) repeat` }}>
        {children}
      </div>

      <Footer projectName={projectName} logo={EDBLogo} columns={footerColumns} simpleVersion={simpleFooter} />
    </main>
  );
};
